{
  "login": {
    "title": "Accedi",
    "emailLabel": "Indirizzo email",
    "passwordLabel": "Password",
    "rememberMe": "Ricordami per 30 giorni",
    "submitButton": "Accedi",
    "submittingButton": "Accesso in corso...",
    "forgotPassword": "Password dimenticata?",
    "setNewPassword": "Imposta una nuova password qui",
    "sessionExpired": "Sessione scaduta",
    "noAccountYet": "Non hai ancora un account?",
    "createOne": "Creane uno"
  },
  "forgotPassword": {
    "title": "Password dimenticata",
    "emailLabel": "Indirizzo email",
    "submitButton": "Invia link di reimpostazione password alla tua email",
    "backToLogin": "Torna al login",
    "submittingButton": "Invio in corso...",
    "successTitle": "Controlla la tua casella di posta",
    "successMessage": "Se esiste un account per questo indirizzo, ti abbiamo inviato un link di reimpostazione via email."
  },
  "confirmEmail": {
    "confirming": "Conferma della tua email in corso…",
    "successTitle": "Email confermata",
    "successMessage": "Il tuo indirizzo email è stato confermato. Ora puoi accedere al tuo account.",
    "continueToLogin": "Continua al login",
    "errorTitle": "Conferma non riuscita",
    "errorMessage": "Non siamo riusciti a confermare la tua email. Il link potrebbe essere non valido o scaduto."
  },
  "resetPassword": {
    "title": "Reimposta password",
    "subtitle": "Inserisci la tua nuova password qui sotto",
    "newPasswordLabel": "Nuova password",
    "newPasswordPlaceholder": "Inserisci la tua nuova password",
    "confirmPasswordLabel": "Conferma la nuova password",
    "confirmPasswordPlaceholder": "Conferma la tua nuova password",
    "passwordsDoNotMatch": "Le password non corrispondono",
    "submitButton": "Imposta nuova password",
    "submittingButton": "Reimpostazione in corso...",
    "invalidToken": "Token di reimpostazione non valido",
    "fixRequirements": "Correggi i requisiti della password",
    "failedReset": "Impossibile reimpostare la password"
  },
  "acceptTerms": {
    "title": "Termini e condizioni",
    "subtitle": "Leggi e accetta i nostri termini per continuare",
    "welcomeTitle": "Benvenuto su Flipping Pal!",
    "welcomeBody": "Questi termini e condizioni delineano le regole e i regolamenti per l'utilizzo del sito web di Flipping Pal, disponibile su",
    "welcomeBody2": "Accedendo a questo sito web, si presuppone che tu accetti questi termini e condizioni. Non continuare a usare Flipping Pal se non accetti tutti i termini e le condizioni indicati in questa pagina.",
    "keyPointsTitle": "Punti chiave:",
    "keyPoints": {
      "0": "Flipping Pal possiede tutti i diritti di proprietà intellettuale sui materiali di questo sito web",
      "1": "Non puoi ripubblicare, vendere o ridistribuire contenuti di Flipping Pal",
      "2": "Utilizziamo cookie per migliorare la tua esperienza sul nostro sito web",
      "3": "I commenti degli utenti non riflettono le opinioni di Flipping Pal",
      "4": "Ci riserviamo il diritto di modificare questi termini in qualsiasi momento",
      "5": "I contenuti del sito web sono forniti \"così come sono\" senza garanzie"
    },
    "responsibilitiesTitle": "Le tue responsabilità:",
    "responsibilities": {
      "0": "Usa il servizio in conformità con tutte le leggi applicabili",
      "1": "Mantieni la sicurezza delle credenziali del tuo account",
      "2": "Non tentare di compromettere la sicurezza dei nostri sistemi",
      "3": "Rispetta i diritti di proprietà intellettuale"
    },
    "previewNote": "📄 Questa è un'anteprima dei nostri Termini e condizioni. Clicca su \"Visualizza tutti i termini\" per leggere il documento completo.",
    "viewFullTerms": "Visualizza tutti i Termini e condizioni (apre in una nuova scheda)",
    "checkboxLabel": "Ho letto e accetto i Termini e condizioni",
    "checkboxDescription": "Selezionando questa casella, riconosci di aver letto, compreso e di accettare di essere vincolato da questi termini.",
    "acceptButton": "Accetta e continua",
    "acceptingButton": "Accettazione...",
    "questionsText": "Domande sui nostri termini?",
    "contactSupport": "Contatta il supporto"
  },
  "discord": {
    "linkingTitle": "Collegamento account Discord",
    "linkingBody": "Attendi mentre colleghiamo il tuo account Discord...",
    "successTitle": "Successo!",
    "successBody": "Il tuo account Discord è stato collegato con successo.",
    "successWindowClose": "Questa finestra si chiuderà automaticamente...",
    "successRedirect": "Reindirizzamento alle impostazioni...",
    "errorTitle": "Collegamento non riuscito",
    "errorBody": "Non siamo riusciti a collegare il tuo account Discord.",
    "errorWindowClose": "Questa finestra si chiuderà automaticamente...",
    "errorRedirect": "Reindirizzamento alle impostazioni...",
    "backToSettings": "Torna alle impostazioni"
  },
  "register": {
    "title": "Crea account",
    "subtitle": "Unisciti a noi e inizia il tuo percorso oggi",
    "emailLabel": "Indirizzo email",
    "emailPlaceholder": "Inserisci il tuo indirizzo email",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Crea una password sicura",
    "confirmPasswordLabel": "Conferma password",
    "confirmPasswordPlaceholder": "Conferma la tua password",
    "passwordStrength": "Forza password",
    "strengthStrong": "Forte",
    "strengthMedium": "Media",
    "strengthWeak": "Debole",
    "termsLabel": "Accetto i",
    "termsLink": "Termini e condizioni",
    "termsLabel2": "",
    "submitButton": "Crea account",
    "submittingButton": "Creazione account...",
    "alreadyHaveAccount": "Hai già un account?",
    "signInHere": "Accedi qui",
    "registrationClosed": "Registrazione attualmente non disponibile",
    "registrationClosedMessage": "Al momento le registrazioni sono chiuse",
    "fixFormErrors": "Correggi gli errori del modulo prima di inviare",
    "acceptTermsRequired": "Accetta i Termini e condizioni per continuare",
    "registrationFailed": "Registrazione fallita. Riprova."
  },
  "errorBoundary": {
    "title": "Qualcosa è andato storto",
    "subtitle": "Si è verificato un errore imprevisto. Non preoccuparti — i tuoi dati sono al sicuro.",
    "unknownError": "Errore sconosciuto",
    "goHome": "Vai alla home",
    "reloadPage": "Ricarica pagina",
    "logout": "Esci",
    "showErrorDetails": "Mostra dettagli errore",
    "hideErrorDetails": "Nascondi dettagli errore",
    "copyToClipboard": "Copia negli appunti",
    "copied": "Copiato!",
    "copy": "Copia",
    "errorLabel": "Errore",
    "componentStackLabel": "Stack componenti",
    "reference": "Riferimento"
  }
}
